<script setup>
import { ref, computed, onMounted } from 'vue';
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import store from '../../state/store';
import moment from 'moment'
import { cloneDeep } from 'lodash';

const title = ref('Delivered/Returned RTS');

const items = ref([
  {
    text: "Home",
  },
  {
    text: "Tracking",
  },
  {
    text: "Delivered/Returned RTS",
    active: true,
  },
]);

const submitted = ref(false);
const notification = computed(() => store.state.notification)
const loading = computed(() => store.state.globals.loading);

const search = ref({
  tracking_number: '',
  status: 'DELIVERED'
});

const input_tracking_number = ref(null);

const results = computed(() => store.state.tracking.trackingBarcodeLogs);

const cloneSearch = ref(null);

const scanTrackingBarcode = async () => {
  cloneSearch.value = null;

  try {
    submitted.value = true;
    await store.dispatch('tracking/getAllTrackingEntriesByScanBarcode', search.value)
    
    if (notification.value.message === null) {
      cloneSearch.value = cloneDeep(search.value);
    }

    setTimeout(() => {
      search.value.tracking_number = '';
      input_tracking_number.value.focus();
    }, 1200)    
  } catch (err) {
    console.log(err);
  }
}

const scanTrackingBarcodeWithTimeout = () => {
  setTimeout(scanTrackingBarcode, 0);
}

onMounted(() => {
  input_tracking_number.value.focus();
})
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-md-12 col-lg-4">
        <div class="card">
          <div class="card-header">
            <h4>Delivered/Returned RTS</h4>
            <div class="text-muted">Search barcode and set the status</div>
          </div>
          <div class="card-body">
              <form @submit.prevent="scanTrackingBarcode">
                <div class="mb-3">
                  <!-- Inline Radios -->
                  <div class="d-flex justify-content-around">
                    <div class="form-check form-radio-success form-check-inline">
                      <input @change="input_tracking_number.focus()" v-model="search.status" value="DELIVERED" class="form-check-input" type="radio" name="inlineRadioOptions1" id="inlineRadio1">
                      <label class="form-check-label text-success" for="inlineRadio1">Delivered</label>
                    </div>
                    <div class="form-check form-radio-danger form-check-inline">
                      <input @change="input_tracking_number.focus()" v-model="search.status" value="RETURNED" class="form-check-input" type="radio" name="inlineRadioOptions2" id="inlineRadio2">
                      <label class="form-check-label text-danger"  for="inlineRadio2">Returned</label>
                    </div>
                  </div>
                </div>
                <div class="mb-3">
                  <label for="barcode" class="form-label">Scan Tracking Barcode</label>
                  <input
                    autocomplete="off"
                    @paste="scanTrackingBarcodeWithTimeout"
                    @keydown.enter="scanTrackingBarcode"
                    ref="input_tracking_number"
                    type="text" autofocus v-model="search.tracking_number" class="form-control" id="barcode" placeholder="Type or scan tracking barcode and press enter...">
                </div>
                <!-- <div class="mb-3">
                  <button type="submit" :disabled="!search.tracking_number" class="btn btn-primary">
                    <i class="mdi mdi-content-save fs-4 text mr-2 align-middle"></i> Search and Update
                  </button>
                </div> -->
              </form>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-lg-8">
        <b-overlay :show="loading">
          <div class="card">
            <div class="card-body">
              <div v-if="results && results.tracking_status_entries.length && submitted" class="table-card m-1">
                <h4 class="mb-4">Tracking Number: {{ cloneSearch ? cloneSearch.tracking_number : 'N/A' }}</h4>
                <table class="table table-nowrap">
                    <thead class="table-light">
                        <tr>
                          <th scope="col">Logs</th>
                          <th scope="col">Status</th>
                          <th scope="col">Date Received</th>
                        </tr>
                    </thead>
                    <tbody> 
                        <tr v-for="result in results.tracking_status_entries" :key="result.id">
                            <td>
                              {{ results.tracking_number ? results.tracking_number : 'No tracking number' }}
                            </td>
                            <td>
                              {{ result.tracking_status_type ? result.tracking_status_type.system_name : 'No status' }}
                            </td>
                             <td>
                              {{ moment(result.created_at).format('YYYY-MM-DD hh:mm A') }}
                            </td>
                        </tr>
                    </tbody>
                </table>
              </div>
              <div v-else-if="results && results.tracking_status_entries.length === 0 && !notification.message && submitted">
                <div class="text-center">
                  <div class="row justify-content-center">
                    <div class="col-lg-9">
                      <h4 class="mt-4 fw-semibold">Delivered/Returned RTS</h4>
                      <p class="text-danger mt-3 fs-16 text"> 
                        No tracking entries found!
                      </p>
                    </div>
                  </div>
                  <div class="row justify-content-center mt-5 mb-2">
                    <div class="col-sm-7 col-8">
                      <img src="@/assets/images/file.png" alt="" class="img-fluid">
                    </div>
                  </div>
                </div>
              </div>
               <div v-else-if="notification && notification.message && submitted">
                <div class="text-center">
                  <div class="row justify-content-center">
                    <div class="col-lg-9">
                      <h4 class="mt-4 fw-semibold">Delivered/Returned RTS</h4>
                      <p class="text-danger mt-3 fs-16 text"> 
                        {{ notification.message }}
                      </p>
                    </div>
                  </div>
                  <div class="row justify-content-center mt-5 mb-2">
                    <div class="col-sm-7 col-8">
                      <img src="@/assets/images/error500.png" alt="" class="img-fluid">
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="text-center">
                  <div class="row justify-content-center">
                    <div class="col-lg-9">
                      <h4 class="mt-4 fw-semibold">Delivered/Returned RTS</h4>
                      <p class="text-muted mt-3 fs-16 text"> 
                        Scanned tracking barcode results will show up their results here
                      </p>
                    </div>
                  </div>
                  <div class="row justify-content-center mt-5 mb-2">
                    <div class="col-sm-7 col-8">
                      <img src="@/assets/images/file.png" alt="" class="img-fluid">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>